import {
  Box,
  Button,
  Container,
  InputLabel,
  Paper,
  TextField
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import Navbar from "../../../components/Navbar";
import HeaderSteps from "../../../components/auth/HeaderSteps";
import ReactCodeInput from "react-code-input";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import { loginTeacher } from "../../../redux/teacherSlice";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";

export default function TeacherThirdStep() {
  const dispatch = useDispatch();
  const { closeSnackbar, enqueueSnackbar } = useSnackbar();
  const input1 = useRef();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const lang = Cookies.get("i18next") || "en";
  const [inviteLink, setInviteLink] = useState("");

  useEffect(() => {
    if (!localStorage.getItem("teacherCode")) {
      navigate("/teacherRegister/step1");
    }
  }, [navigate]);

  async function savePassword() {
    closeSnackbar();
    try {
      const password = input1.current?.state?.value;

      if (!password || password.length !== 4) {
        enqueueSnackbar(t("passwordLengthError") || "Length should be 4", {
          variant: "error",
          autoHideDuration: 8000,
        });
        return;
      }

      const response = await fetch(
        `${process.env.REACT_APP_API_KEY}api/v1/teacher/signup/pass`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            password,
            email: localStorage.getItem("teacherEmail"),
            lang,
            inviteLink: inviteLink || undefined, // Send only if not empty
          }),
        }
      );

      const resData = await response.json();

      if (response.status !== 200 && response.status !== 201) {
        enqueueSnackbar(
          lang === "ar" ? resData.message.arabic : resData.message.english,
          { variant: "error", autoHideDuration: 8000 }
        );
        return;
      }

      enqueueSnackbar(
        lang === "ar" ? resData.message.arabic : resData.message.english,
        { variant: "success", autoHideDuration: 8000 }
      );

      const loginRes = await fetch(
        `${process.env.REACT_APP_API_KEY}api/v1/login`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            password,
            email: localStorage.getItem("teacherEmail"),
            long: localStorage.getItem("longitude"),
            lat: localStorage.getItem("latitude"),
          }),
        }
      );

      const loginData = await loginRes.json();

      if (loginRes.status !== 200 && loginRes.status !== 201) {
        enqueueSnackbar(loginData.message, {
          variant: "error",
          autoHideDuration: 8000,
        });
        return;
      }

      localStorage.clear();
      dispatch(loginTeacher({ token: loginData.token, teacher: loginData.data }));
      navigate("/teacher/about");
    } catch (error) {
      console.error("Error:", error);
    }
  }

  return (
    <Navbar>
      <Container sx={{ marginTop: "110px" }}>
        <Paper
          sx={{
            width: { md: "600px" },
            padding: "30px 50px",
            margin: "60px auto",
          }}
        >
          <HeaderSteps step={3} title={t("Complete the teacher's data")} steps={3} />

          {/* Invitation Link Field */}
          <Box sx={{ marginBottom: "30px" }}>
            <InputLabel sx={{ marginBottom: "10px", fontSize: "17px" }}>
              {t("Invitation link (optional)")}
            </InputLabel>
            <TextField
              fullWidth
              placeholder="xxxxx-xxxx-xxxx-xxxx-xxxx"
              value={inviteLink}
              onChange={(e) => setInviteLink(e.target.value)}
              size="small"
            />
          </Box>

          {/* Password Code Input */}
          <InputLabel sx={{ marginBottom: "6px", fontSize: "18px" }}>
            {t("enterpassword")}
          </InputLabel>
          <Box
            sx={{ marginTop: "15px", marginBottom: "80px", direction: "rtl" }}
          >
            <ReactCodeInput type="number" fields={4} ref={input1} />
          </Box>

          <Button
            variant="contained"
            color="secondary"
            fullWidth
            sx={{ textTransform: "capitalize" }}
            onClick={savePassword}
          >
            {t("savepassword")}
          </Button>
        </Paper>
      </Container>
    </Navbar>
  );
}
